module.exports = __webpack_public_path__ + "img/84.0e4e402f.png";